<ion-card class="vehicle-card ion-no-margin">
    <ion-card-content>
        <div class="order-header">
            <div class="order-media-block d-flex align-items-center justify-content-center">
                <img [src]="order().image" class="rounded order-image" [alt]="order().vehicleName">
            </div>

            <div class="order-text-block d-flex flex-column align-items-start">
                <div class="vehicle-title m-0">{{ order().vehicleName }}</div>
                <p class="subtext">
                    {{ order().subtext }}
                </p>
                <span class="allowance-badge d-inline-flex align-items-center justify-content-center"
                    [ngClass]="order().chipClass">
                    {{ order().allowanceStatus }}
                </span>
            </div>
        </div>
        <button type="button" class="info-link p-0 mt-1"
            (click)="standardVehicleInfoModalService.open($event, order().capId)">
            {{ 'STANDARD_VEHICLE_INFORMATION' | translate }}
        </button>

        <ion-row class="pt-3">
            @if (order().estimated_delivery_date) {
            <ion-col size="7">
                <div class="spec-label">
                    {{ 'LABEL_ESTIMATED_DELIVERY_DATE' | translate }}
                </div>
                <div class="spec-value">
                    {{ getEstimatedDeliveryDate() }}
                </div>
            </ion-col>
            }

            @if (order().order_number) {
            <ion-col size="5">
                <div class="spec-label">
                    {{ 'A_LABEL7' | translate }}
                </div>
                <div class="spec-value">
                    {{ order().order_number }}
                </div>
            </ion-col>
            }
        </ion-row>

        <div class="actions-separator mt-2 pb-3"></div>

        <ion-row class="ion-padding-bottom">
            @if (order().finance.p11d !== null) {
            <ion-col size="4">
                <div class="spec-label">{{ 'LABEL_P11D' | translate }}</div>
                <div class="spec-value">
                    {{ order().finance.p11d | currency:'GBP' }}
                </div>
            </ion-col>
            }

            @if (selectedBIK() === 20 && order().finance.bik20 !== null) {
            <ion-col size="4">
                <div class="spec-label">{{ 'LABEL_BIK_20' | translate }}</div>
                <div class="spec-value">{{ order().finance.bik20 | currency:'GBP' }}</div>
            </ion-col>
            }

            @if (selectedBIK() === 40 && order().finance.bik40 !== null) {
            <ion-col size="4">
                <div class="spec-label">{{ 'LABEL_BIK_40' | translate }}</div>
                <div class="spec-value">{{ order().finance.bik40 | currency:'GBP' }}</div>
            </ion-col>
            }

            @if (selectedBIK() === 45 && order().finance.bik45 !== null) {
            <ion-col size="4">
                <div class="spec-label">{{ 'LABEL_BIK_45' | translate }}</div>
                <div class="spec-value">{{ order().finance.bik45 | currency:'GBP' }}</div>
            </ion-col>
            }

            @if (order().finance.tradeUpDown != null && order().finance.financeLabel !== 'LABEL_UNDER_BUDGET') {
            <ion-col size="4">
                <div class="spec-label">
                    {{ order().finance.financeLabel | translate }}
                </div>
                <div class="spec-value">
                    {{ order().finance.tradeUpDown | currency:'GBP' }}
                </div>
            </ion-col>
            }
        </ion-row>

        <ion-row class="spec-row-wrap ion-padding-bottom">
            @if (order().specs.fuelType) {
            <ion-col size="4">
                <div class="spec-label">{{ 'LABEL_FUEL_TYPE' | translate }}</div>
                <div class="spec-value">
                    {{ order().specs.fuelType }}
                </div>
            </ion-col>
            }

            @if ((order().specs.mpg ?? 0) > 0) {
            <ion-col size="4">
                <div class="spec-label">{{ 'LABEL_MPG' | translate }}</div>
                <div class="spec-value">
                    {{ order().specs.mpg }}
                </div>
            </ion-col>
            }

            @if ((order().specs.co2 ?? 0) > 0) {
            <ion-col size="4">
                <div class="spec-label">{{ 'LABEL_CO2' | translate }}</div>
                <div class="spec-value">
                    {{ order().specs.co2 }} g/km
                </div>
            </ion-col>
            }

            @if ((order().specs.ev_miles ?? 0) > 0) {
            <ion-col size="4">
                <div class="spec-label">{{ 'LABEL_EV_MILES' | translate }}</div>
                <div class="spec-value">
                    {{ order().specs.ev_miles }}
                </div>
            </ion-col>
            }
        </ion-row>

        <div class="actions-separator"></div>

        <div class="d-flex justify-content-center mt-1">
            <ion-button fill="clear" class="view-details-btn ion-no-margin">
                <span class="d-flex align-items-center">
                    {{ 'VIEW_DETAILS' | translate }}
                    <ion-icon name="chevron-down-sharp"></ion-icon>
                </span>
            </ion-button>
        </div>
    </ion-card-content>
</ion-card>